

<sm-title-bar  pageTitle="Membership request Details" [back]="true"></sm-title-bar>

<div class="member_details_view" *ngIf="!loader && interestDetails.length > 0">
<div class="container">
  <div class="row">
   <div class="col-sm-8 mobile-pnloyet">
 

      <div class="salon_mei_section">
    <mat-card appearance="outlined">
      <div class="exert_opd">
        <div class="opert_section">
          <button mat-icon-button [matMenuTriggerFor]="menu" class="more-button" aria-label="More options" *ngIf="interestDetails[0].enrollment_request_status != 5  || (isOwner && interestDetails[0].enrollment_request_status == 5 && (!interestDetails[0].customer_account_hash ||  interestDetails[0].customer_account_hash == 'null'))">
            <mat-icon>more_vert</mat-icon>
          </button>
          <button mat-icon-button [matMenuTriggerFor]="menu" class="more-button" aria-label="More options" *ngIf="interestDetails[0].enrollment_request_status == 5">
            <mat-icon>more_vert</mat-icon>
          </button>
           <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="addReply(interestDetails[0])">
         <mat-icon class="material-icons-outlined">reply</mat-icon>
         <span>Reply</span>
         </button>
         <button mat-menu-item (click)="changeRequestStatus(interestDetails[0],1)" *ngIf="interestDetails[0].enrollment_request_status != 1 &&  interestDetails[0].enrollment_request_status != 5">
         <mat-icon class="material-icons-outlined">grade</mat-icon>
         <span>Mark as new</span>
         </button>
         <button mat-menu-item (click)="changeRequestStatus(interestDetails[0],2)" *ngIf="interestDetails[0].enrollment_request_status != 2 &&  interestDetails[0].enrollment_request_status != 5">
         <mat-icon class="material-icons-outlined">hourglass_top</mat-icon>
         <span>Mark as in-progress</span>
         </button>
         <button mat-menu-item (click)="changeRequestStatus(interestDetails[0],3)" *ngIf="interestDetails[0].enrollment_request_status != 3 &&  interestDetails[0].enrollment_request_status != 5">
         <mat-icon class="material-icons-outlined">task_alt</mat-icon>
         <span>Mark as enrolled</span>
         </button>
         <button mat-menu-item (click)="changeRequestStatus(interestDetails[0],4)" *ngIf="interestDetails[0].enrollment_request_status != 4 &&  interestDetails[0].enrollment_request_status != 5">
         <mat-icon class="material-icons-outlined">cancel</mat-icon>
         <span>Mark as cancelled</span>
         </button>
         <button mat-menu-item (click)="addAsMember(interestDetails[0])" *ngIf="interestDetails[0].enrollment_request_status == 3 &&  interestDetails[0].enrollment_request_status != 5">
         <mat-icon class="material-icons-outlined">person_add</mat-icon>
         <span> Add in enrolled members</span>
         </button>

         <button mat-menu-item (click)="deleteQuery(interestDetails[0])" *ngIf="(!interestDetails[0].customer_account_hash ||  interestDetails[0].customer_account_hash == 'null') && (isOwner)">
         <mat-icon class="material-icons-outlined">delete</mat-icon>
         <span> Delete query</span>
         </button>
           </mat-menu>
        </div>

        <div class="joining_list_flex">
        <div class="salon_img_member">
          <img [src]="interestDetails[0].image_thumb_url" onerror="this.src='../../../../../assets/images/user-avatar.svg'" alt="">
        </div>
        <div class="hair_ct_heading">
          <div class="rahul_headert">
            <h4>{{interestDetails[0].customer_name}}</h4>
            <p>{{interestDetails[0].customer_country_code}} {{interestDetails[0].customer_phone}}</p>
            <p>{{interestDetails[0]?.email && interestDetails[0]?.email != '' && interestDetails[0]?.email != 'null' ? interestDetails[0]?.email : 'No email added'}} </p>
            <p>{{interestDetails[0].creation_time | date : 'MMM d, y, h:mm a' : 'UTC'}}</p>
          </div>
        </div>
       </div>

        <div class="joining_list" >
          <p style="font-size: 12px;
    color: #888;">
          <span class="joining_point" [class.new-booking]="interestDetails[0].enrollment_request_status == 1" [class.under-process]="interestDetails[0].enrollment_request_status == 2 " [class.completed]="interestDetails[0].enrollment_request_status == 5" [class.cancelled]="interestDetails[0].enrollment_request_status == 4 " [class.confirmed]="interestDetails[0].enrollment_request_status == 3"></span> <span class="joing_textd"> {{interestDetails[0].item_status}}</span>
          </p>
        </div>


      </div>
    </mat-card>
  </div>
  <div class="workout_timiing_open" *ngIf="interestDetails[0].opted_timings">
    <div class="booking_name_opop">
      <h1>Preferred day and time</h1>
    </div>
       <div class="solt_datef active_chip" style="padding-top: 5px;" >
       <mat-chip-list aria-label="service mode">
      <mat-chip *ngFor="let item of interestDetails[0].opted_timings" selected color="primary">{{item}}</mat-chip>
    </mat-chip-list>
    </div>
  </div>


  <div class="right_deatils_pp" *ngIf="interestDetails[0].request_services || interestDetails[0].products || interestDetails[0].custom_items ">
    <!-- Opted services -->
    <div class="sub_ser" *ngIf="interestDetails[0].request_services">
      <h3 class="sub_headingt">Service / package interested in</h3>
      <div class="service_mode_chip">
        <div class="row">
          <div class="col-sm-4" *ngFor="let item of interestDetails[0].request_services">
            <div class="service_listh">
              <div class="bus_img" *ngIf="item.img_url && item.img_url != 'null'">
                <img [src]="item.img_url" onerror="this.src='../../../../../assets/images/photo.png'" alt="">
              </div>
               <div class="placeholder_headingv" *ngIf="!item.img_url || item.img_url == 'null'">
                              <p>{{item.service_name.slice(0,1).toUpperCase()}}</p>
                           </div>
              <div class="bus_hjk">
                <h4 class="prodcut_heading">{{item.service_name}} X {{item.service_qty}}</h4>
                <p>{{item.currency_symbol}}{{item.rate.toFixed(2)}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Opted products -->
    <div class="sub_ser" *ngIf="interestDetails[0].products">
      <h3 class="sub_headingt">Preffered products</h3>
      <div class="service_mode_chip">
        <div class="row">
          <div class="col-sm-4" *ngFor="let item of interestDetails[0].products">
            <div class="service_listh">
              <div class="bus_img" *ngIf="item.img_url && item.img_url != 'null'">
                <img [src]="item.img_url" onerror="this.src='../../../../../assets/images/photo.png'" alt="">
              </div>
               <div class="placeholder_headingv" *ngIf="!item.img_url || item.img_url == 'null'">
                              <p>{{item.product_name.slice(0,1).toUpperCase()}}</p>
                           </div>
              <div class="bus_hjk">
                <h4 class="prodcut_heading">{{item.product_name}} X {{item.product_qty}}</h4>
                <p>{{item.currency_symbol}}{{item.rate.toFixed(2)}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Other items -->
    <div class="sub_ser" *ngIf="interestDetails[0].custom_items">
      <h3 class="sub_headingt">Other interest</h3>
      <div class="service_mode_chip">
        <div class="row">
          <div class="col-sm-4" *ngFor="let item of interestDetails[0].custom_items">
            <div class="service_listh">
              <div class="placeholder_headingv" >
                              <p>{{item.item_name.slice(0,1).toUpperCase()}}</p>
                           </div>
              <div class="bus_hjk">
                <h4 class="prodcut_heading">{{item.item_name}} X {{item.item_qty}}</h4>
                <p>{{item.currency_symbol}}{{item.item_price.toFixed(2)}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Notes -->
    <div class="trainer_start" *ngIf="(interestDetails[0].customer_notes && interestDetails[0].customer_notes != 'null') || (interestDetails[0].entity_reply && interestDetails[0].entity_reply != 'null')">
    <mat-card appearance="outlined">
      <div class="trainer_list" *ngIf="interestDetails[0].customer_notes && interestDetails[0].customer_notes != 'null' && interestDetails[0].customer_notes != ''">
        <div class="trainer_img">
          <img [src]="interestDetails[0].image_thumb_url" onerror="this.src='../../../../../assets/images/user-avatar.svg'" alt="">
        </div>
        <div class="trainer_heading">
          <h3>Customer Notes</h3>
          <p>{{interestDetails[0].customer_notes}}</p>
        </div>
      
      </div>

        <div class="trainer_list bor_top" *ngIf="interestDetails[0].entity_reply && interestDetails[0].entity_reply != 'null' && interestDetails[0].entity_reply != ''">
        <div class="trainer_img">
          <img [src]="interestDetails[0].entityInfo.default_thumb_image" onerror="this.src='../../../../../assets/images/photo.png'" alt="">
        </div>
        <div class="trainer_heading">
          <h3>Business reply</h3>
           <p class="date_rgt">{{interestDetails[0].entity_reply_date | date : 'MMM d, y, h:mm a': 'UTC'}}</p>
          <p>{{interestDetails[0].entity_reply}}</p>
        </div>
      
      </div>
       
    </mat-card>
  </div>

</div>

<div class="col-sm-4 joining_interd">
 
   <div class="workout_timiing_open servicemode">
    <div class="booking_name_opop">
      <h1 style="margin-bottom: 0px !important;">Service mode selected</h1>
    </div>
    <div class="solt_datef ">
      <mat-chip-list aria-label="service mode">
      <mat-chip selected color="primary">{{interestDetails[0].service_mode}}</mat-chip>
      </mat-chip-list>
      </div>
  </div>


     <div class="coupon_applied" *ngIf="interestDetails[0].coupon_code && interestDetails[0].coupon_code != '' && interestDetails[0].coupon_code != 'null'">
    <mat-card appearance="outlined">
      <div class="coupon-card">
          <h3>Coupon applied
          </h3>
          <div class="coupon-row">
              <span id="cpnCode">{{interestDetails[0].coupon_code}}</span>
              <!-- <span id="cpnBtn">Copy Code</span> -->
          </div>
          <!-- <div class="circle1"></div>
          <div class="circle2"></div> -->
      </div>
    </mat-card>
  </div>

 <div class="booking_detail_info">
      <p>{{interestDetails[0].entityInfo.name}}</p>
      <p class="address_frt">{{interestDetails[0].entityInfo.address}}</p>
      </div>



</div>



  </div>
</div>
</div>